(function () {
  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function positionFromEvent(media, clientX) {
    var rect = media.getBoundingClientRect();
    var ratio = (clientX - rect.left) / rect.width;
    return clamp(ratio, 0, 1) * 100;
  }

  function setPosition(media, percent) {
    media.style.setProperty('--ba-position', percent + '%');
  }

  function initMedia(media) {
    if (media.dataset.baInitialized === 'true') return;
    media.dataset.baInitialized = 'true';

    var handle = media.querySelector('[data-ba-handle]');
    var dragging = false;

    function onPointerDown(event) {
      dragging = true;
      if (handle && handle.setPointerCapture && event.pointerId != null) {
        try {
          handle.setPointerCapture(event.pointerId);
        } catch (e) {
          // ignore
        }
      }
      setPosition(media, positionFromEvent(media, event.clientX));
      event.preventDefault();
    }

    function onPointerMove(event) {
      if (!dragging) return;
      setPosition(media, positionFromEvent(media, event.clientX));
    }

    function onPointerUp() {
      dragging = false;
    }

    if (handle) {
      handle.addEventListener('pointerdown', onPointerDown);
    }
    media.addEventListener('pointerdown', function (event) {
      if (event.target === handle || (handle && handle.contains(event.target))) return;
      dragging = true;
      setPosition(media, positionFromEvent(media, event.clientX));
    });
    window.addEventListener('pointermove', onPointerMove);
    window.addEventListener('pointerup', onPointerUp);
    window.addEventListener('pointercancel', onPointerUp);
  }

  function initSection(section) {
    var mediaEls = section.querySelectorAll('[data-ba-media]');
    mediaEls.forEach(initMedia);
  }

  function initAll() {
    document.querySelectorAll('.car-care-ba').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.car-care-ba');
    if (section) initSection(section);
  });
})();
